import BankDetails from "../../../../_utils/AccountCreationComponents/BankDetails";
import CommonLayout from "../../../../_utils/CommonLayout";

function BeneficiaryAccountEditStepBankConfirm({ payload ,manualVirtualAccount}) {
  return (
    <CommonLayout>
      <>
        <BankDetails
          payload={payload}
          headerText={"Updated Account Details"}
          previewMode={true}
          manualVirtualAccount={manualVirtualAccount}
        />
      </>
      <>
        <BankDetails
          payload={payload}
          archivePreviewMode={true}
        />
      </>
    </CommonLayout>
  );
}
export default BeneficiaryAccountEditStepBankConfirm;
